import type {AddRepresentativeContactFormPayload} from "./add-representative-contact.schema";

import {addRepresentativeContact} from "@project/sdk/sales";
import {AddRepresentativeContactBody} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";

import {representativeKeys, representativeMutationKeys} from "../../../../../representative-keys";

import {addRepresentativeContactMapper} from "./add-representative-contact.mapper";

export function addRepresentativeContactMutationOptions(representativeId: string) {
  return mutationOptions({
    mutationKey: representativeMutationKeys.addRepresentativeContact,
    mutationFn: (formPayload: AddRepresentativeContactFormPayload) => {
      const request = AddRepresentativeContactBody.parse(
        addRepresentativeContactMapper.toSdk(formPayload),
      );

      return addRepresentativeContact(representativeId, request);
    },
    onSuccess: async (_contactId, _formPayload, _onMutateResult, {client}) => {
      await client.invalidateQueries({queryKey: representativeKeys.detail(representativeId)});
    },
  });
}
